// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PracticePassEdit
 */
export interface PracticePassEdit {
    /**
     * 
     * @type {string}
     * @memberof PracticePassEdit
     */
    status?: PracticePassEditStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PracticePassEdit
     */
    comment?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PracticePassEditStatusEnum {
    Passed = 'passed',
    NotPassed = 'not_passed',
    Waiting = 'waiting',
    SendToRevision = 'send_to_revision'
}



